// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1__c9a00b42e040f9144329","cls2":"News-cls2___04c9e1f887e156df05e News-cls1__c9a00b42e040f9144329"};